import { Currency, currencySymbol, Product } from '../../utils/payment-utils'
import RadioCard from '../ui/shared/radio-card'

interface ProductOption extends Product {
  disabled: boolean
}

interface ProductOptionsProps {
  products: ProductOption[]
  onChange: (value: string) => void
  currency: Currency
  selectedId?: string
}

export default function ProductOptions({
  products,
  currency,
  onChange,
  selectedId,
}: ProductOptionsProps): JSX.Element {
  return (
    <div className="tw-flex tw-flex-col">
      {products.map(({ id, name, prices, disabled }) => {
        return (
          <RadioCard
            disabled={disabled}
            key={id}
            value={id}
            active={id === selectedId}
            onChange={onChange}>
            <p className="tw-custom-reset-heading tw-font-bold">
              {currencySymbol[currency]}
              {prices[currency]} {name}
            </p>
          </RadioCard>
        )
      })}
    </div>
  )
}
